import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { __enum_PageMode, __MessageTypes, enum__PRIVILEGES } from '../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetList, _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import {  isNullOrEmpty, isNullUndefinedOrEmpty, showMessage } from '../../../../../common/Helpers';
import MessageBox from '../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import { Icon, Toggle, TooltipHost } from '@fluentui/react';
import { useDispatch } from 'react-redux';
import { addListBoardScopeDataseries } from '../../../../../services/sKPI/board.service';
import { useGetListBoardScopeDataseries } from '../../../../../hooks/services/sKPI/useOfBoard';
import { action_setBoardScopeValues } from '../../../../../reducers/actions/KPI/actions';
import { useContext } from 'react';
import JqxNumberInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput';
import CValidator from '../../../../Common/CValidator';
import DatePicker from 'react-datepicker';
import { __onRenderMonthContent, CalendarCustomInput } from '../../../../../common/CommonFuctions';
import moment from 'moment';
import CLabel from '../../../../Common/CLabel';
import { cloneDeep } from 'lodash-es';
import MainAppContext from '../../../../../MainAppContext';
import { _checkSecurityUser } from '../../../../../common/Helpers/HLP_Security';
import BoardAppContext from '../../../../../BoardAppContext';

const SidePanelConfig = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    
    const { 
        inputParam_IsPanelOpen = null,
        inputParam_EditMode = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_Object = null,
        inputParam_ElementId = null,
    } = props;

    const aux_userProps = contextBoard.userPropsKpi.value;

    const _priv_canConfigureConsolidatedGroup = _checkSecurityUser(contextSite.onlyObserver, aux_userProps, contextSite.securityProps, parseInt(inputParam_ElementId), enum__PRIVILEGES.KPI_CONTRACT_GROUP);
    const canEdit = _priv_canConfigureConsolidatedGroup.mode === __enum_PageMode.Edit

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    
    
    const [forceGetScopes, setForceGetScopes] = useState(true)
    const [periodIdChanged, setPeriodIdChanged] = useState(false)
    
    const [currentPeriodId, setCurrentPeriodId] = useState(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1))
    const [filterText, setFilterText] = useState('')
    const [objDataserieWeightListFiltred, setObjDataserieWeightListFiltred] = useState(__OBJECT_STRUCTURE_GetList(999999, null))
    const [objDataserieWeightList, setObjDataserieWeightList] = useState(__OBJECT_STRUCTURE_GetList(999999, null))
    useGetListBoardScopeDataseries(inputParam_Object.id, inputParam_ElementId, objDataserieWeightList, setObjDataserieWeightList, setObjDataserieWeightListFiltred, currentPeriodId, inputParam_IsPanelOpen, forceGetScopes, setForceGetScopes)

    const calculateTotalWeightAndCheckedItems = () => {
        const totalWeight = objDataserieWeightList.data.reduce((acumulador, objeto) => 
            acumulador + ('weight' in objeto ? parseFloat(objeto.weight === "" || objeto.weight === null ? 0 : objeto.weight.toString()) * 100 : 0)
          , 0);
        
        const totalWeightCorrected = totalWeight / 100;

        const hasCheckedItems = objDataserieWeightList.data.some(item => 
            ('checked' in item ? item.checked : (item.weight !== null && item.weight !== undefined))
        );

        return { totalWeightCorrected, hasCheckedItems };
    };

    const validateWeightAndShowMessage = () => {
        const { totalWeightCorrected, hasCheckedItems } = calculateTotalWeightAndCheckedItems();

        if (hasCheckedItems && totalWeightCorrected !== 100) {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-total100'));
        } else {
            showMessage(setMessageConfig, false, null, null);
        }
    };

    const validateForm = () => {
        let isValid = (
            objDataserieWeightList.data !== null &&
            objDataserieWeightList.data !== undefined
        ) ? true : false;

        //Problema de presición de decimales. Gracias Javascript!
        //objDataserieWeightList.data.reduce((acumulador, objeto) => acumulador + ('weight' in objeto ? parseFloat(objeto.weight === "" || objeto.weight === null ? 0 : objeto.weight.toString()) : 0), 0) !== 100

        const { totalWeightCorrected, hasCheckedItems } = calculateTotalWeightAndCheckedItems();

        // If there are checked items, they must sum to 100%
        // If there are no checked items, valid total is 0%
        if (hasCheckedItems) {
            isValid = (totalWeightCorrected === 100);
        } else {
            isValid = (totalWeightCorrected === 0);
        }

        return isValid
    }

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null);

        window.location.href = window.location.href;
    };

    const prepareObjectsToSend = (objects) => {
        let objectsToSave = [];
        objects.forEach(element => {
            element.periodId = new Date(currentPeriodId.getFullYear(), currentPeriodId.getMonth(), 1);
            element.variableName = "";
            element.weight = element.weight === null ? 0 : element.weight;
            element.wieghtGoal = element.weight === null ? 0 : element.weight;
            objectsToSave.push(element)
        });

        return objectsToSave;
    }

    const onEditItem = () => {
        if (objDataserieWeightList.length > 0 || objDataserieWeightList.data.length > 0)
        {
            if (validateForm()) { 
                const old_data = cloneDeep(objDataserieWeightList.data);

                const aux_objectToSend = old_data.filter(x => (x.checked === true && (x.weight !== '')) || ((x.checked === undefined) && x.weight >= 0 && x.weight !== null))

                const aux_titles = []
                aux_objectToSend.map(x => {
                    aux_titles.push({dataserieId: x.dataserieId, variableName: x.variableName})
                })

                const objectsToSend = prepareObjectsToSend(aux_objectToSend);              

                addListBoardScopeDataseries(inputParam_Object.id, inputParam_ElementId, objectsToSend, currentPeriodId).then((response) => {
                    if (response.data.succeeded) {

                        dispatch(action_setBoardScopeValues({objectList: null}));

                        //##[REVISAR ->>> Aquí va la asignación o re busqueda de los elementos para que tengan id y no se dupliquen.]##
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                const totalWeight = objDataserieWeightList.data.reduce((acumulador, objeto) => 
                    acumulador + ('weight' in objeto ? parseFloat(objeto.weight === "" || objeto.weight === null ? 0 : objeto.weight.toString()) * 100 : 0)
                  , 0);
        
                const totalWeightCorrected = totalWeight / 100;
        
                if (totalWeightCorrected !== 100) {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-total100'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
                }
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectdataserietoscope'))
        }
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const handleDateChange = (value) => {
        setCurrentPeriodId(value);
        setForceGetScopes(true)
        setPeriodIdChanged(true)
    };

    const onRenderHeader = () => {
        return (
            <Row className='ms-2'>
                <Col xl={12}>
                    <h4 style={{ margin: 0 }}>{t('data-lang-boxname-configurationconsolidatedgroup')}</h4>
                </Col>
                <Col xl={12} className="pt-5">
                    <div className='border-bottom h5'>{inputParam_Object.name}</div>
                </Col>
                <Col xl={12} className='pt-3'>
                    <Row className='pb-3'>
                        <Col className='col-auto text-start'><b>{t('data-lang-lbl-filter')}</b></Col>
                        <Col className='text-end'>
                            <input type='text' className='w-100' value={filterText} onChange={onChangeFilterText} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-1 mb-2">
                            <CLabel labelText={ t('data-lang-lbl-period') } /><br/>
                            <div className='d-flex' style={{width: "fit-content"}} >
                                <DatePicker
                                    selected={ moment(currentPeriodId, "YYYY/MM").toDate() } 
                                    onChange={(date) => handleDateChange(date)}
                                    height={25}
                                    width={"100%"}
                                    dateFormat="yyyy/MM"
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    renderMonthContent={__onRenderMonthContent}
                                    placeholderText={ t('data-lang-lbl-period') } 
                                    className="form-control"
                                    customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                />
                            </div>
                        </Col>
                    </Row>
                    {
                        objDataserieWeightList.data && objDataserieWeightList.data.filter(x => x.id === 0 && (x.weight !== null || x.checked === true)).length > 0 && periodIdChanged &&
                        <Row>
                            <Col>
                                <MessageBox
                                    inputParam_Message={ t('data-lang-msg-consolidatedgroup-saveadvaice') }
                                    inputParam_Display={ true }
                                    inputParam_MessageType={ __MessageTypes.INFO }
                                    inputParam_SetterMessage={ null }
                                />
                            </Col>
                        </Row>
                    }
                    
                    <Row>
                        <Col className='col-auto text-start'><b>{t('data-lang-lbl-kpilist')}</b></Col>
                        <Col></Col>
                        <Col className='col-auto text-end'><b>{`${t('data-lang-lbl-weight')} / ${t('data-lang-lbl-associate')}`}</b></Col>
                    </Row>
                </Col>
            </Row>
        );
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <Row className="pt-3 pe-2">
                            <Col className='d-flex'>
                                &nbsp;
                            </Col>
                            <Col className='d-flex col-auto me-auto'>
                                <div className="my-auto"><b>Total</b>:&nbsp;{ objDataserieWeightList.data !== null ? calculatePercent() : "0"}%</div>
                            </Col>
                            <Col className='col-auto me-auto'>
                                {
                                    objDataserieWeightList.data !== null &&
                                    <Toggle
                                        label={ objDataserieWeightList.data.length ===  objDataserieWeightList.data.filter(x => x.checked).length || objDataserieWeightList.data.filter(x => x.checked).length === objDataserieWeightList.data.length ? t('data-lang-lbl-all') : t('data-lang-lbl-nothing') }
                                        checked={ objDataserieWeightList.data.length ===  objDataserieWeightList.data.filter(x => x.checked).length || objDataserieWeightList.data.filter(x => x.checked).length === objDataserieWeightList.data.length }
                                        onChange={() => onChangeAllAssociateConsolidation()}
                                        className="my-auto"
                                        disabled={!canEdit}
                                        styles={ { container:{ paddingTop: "4px" }, root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                    />
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            canEdit && 
                            <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const onChangeAssociateConsolidation = (dataserie) => {
        objDataserieWeightList.data.forEach(item => {
            if (item.dataserieId === dataserie.dataserieId) {
                item.checked = !dataserie.checked;
                item.weight = !dataserie.checked ? 0 : null;
                item.wieghtGoal = !dataserie.checked ? 0 : null;
                item.initialValFired = false
            }
        });

        setObjDataserieWeightList && setObjDataserieWeightList(prevState => ({
            ...prevState,
            data: objDataserieWeightList.data,
            fireUpdate:true
        }))

        // Validate after toggle change
        validateWeightAndShowMessage();
    };

    const onChangeAllAssociateConsolidation = () => {
        let allChecked = (objDataserieWeightList.data.filter(x => x.checked).length === objDataserieWeightList.data.length);
        
        objDataserieWeightList.data.forEach(item => {
            item.checked = !allChecked;
            item.weight = item.checked === true ? ((item.weight > 0) ? item.weight : 0) : null;
            item.wieghtGoal = item.checked === true ? ((item.weight > 0) ? item.weight : 0) : null;
            item.initialValFired = false
        });
        
        setObjDataserieWeightList && setObjDataserieWeightList(prevState => ({
            ...prevState,
            data: objDataserieWeightList.data,
            fireUpdate:true
        }))

        // Validate after toggle change
        validateWeightAndShowMessage();
    };

    const onChangeObjConsolidation = (event, texBoxName) => {
        const dataserieId = texBoxName.split("_")[1]

        objDataserieWeightList.data.forEach(item => {
            if (item.dataserieId === parseInt(dataserieId)) {
                item.weight = !isNullUndefinedOrEmpty(event) && !isNullUndefinedOrEmpty(event.args) ? event.args.value : ""
                item.initialValFired = true
            }
        });

        // Validate after weight change
        validateWeightAndShowMessage();
    }; 

    const calculatePercent = () => {
        let aux_objDataserieWeightList = objDataserieWeightList.data.filter(x => x.weight !== null).map(x => parseFloat(x.weight));
        let totalWeight = aux_objDataserieWeightList.length > 0 ? aux_objDataserieWeightList.reduce((acum, obj) => acum + obj) : 0;
        totalWeight = Math.round(totalWeight * 100) / 100;

        return totalWeight;
    }

    const onChangeFilterText = (event) => {
        setFilterText(event.target.value)

        const aux_data = !isNullUndefinedOrEmpty(event.target.value) ? objDataserieWeightList.data.filter(x =>
            x.variableName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 ||
            x.um.toLowerCase().indexOf(filterText.toLowerCase()) !== -1) : objDataserieWeightList.data

        setObjDataserieWeightListFiltred && setObjDataserieWeightListFiltred(prevState => ({
            ...prevState,
            data: aux_data,
            fireUpdate:true
        }))
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ false }
                onDismiss={ onDismissPanel }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                onRenderHeader={onRenderHeader}
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                        {
                            inputParam_IsPanelOpen && objDataserieWeightListFiltred && objDataserieWeightListFiltred.data &&
                            objDataserieWeightListFiltred.data.map((item, index) => (
                                <Row key={item.dataserieId} className={`py-2`}>
                                    <Col>
                                        <div style={{fontSize: "12px", borderLeft: `10px solid ${/*element.htmlColor*/''}`}} className='d-flex pt-2 ps-2'>
                                            <b>{ `${item.contractual === true ? '(C) ' : ''}${item.variableName}` }</b>&nbsp;
                                            <div>
                                                <TooltipHost content={ item.um } >
                                                    <div>({ item.um })</div>
                                                </TooltipHost>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col className='col-auto mx-auto pt-2'>
                                        {
                                            ('checked' in item ? item.checked : (isNullOrEmpty(item.weight) ? false : true)) &&
                                            <>
                                                <JqxNumberInput
                                                    inputMode="simple"
                                                    width={80}
                                                    height={25}
                                                    symbolPosition={'right'}
                                                    symbol={'%'}
                                                    digits={3}
                                                    value={item.weight !== null ? item.weight : 0}
                                                    groupSeparator= ','
                                                    decimalSeparator= '.'
                                                    onChange={(e) => onChangeObjConsolidation(e, `value_${item.dataserieId}`)}
                                                    disabled={!canEdit}
                                                />
                                                <CValidator
                                                    isInValid={item.initialValFired ? (!isNullUndefinedOrEmpty(item.checked) ? isNullOrEmpty(item.weight) : false) : false}
                                                    isInvalidText={"Error"}
                                                />
                                            </>
                                        }
                                        {
                                            !('checked' in item ? item.checked : (isNullOrEmpty(item.weight) ? false : true)) &&
                                            <input type='text' className="w-80px" disabled={true} value="" height={25} />
                                        }
                                    </Col>
                                    <Col className='col-auto mx-auto pt-2'>
                                        <Toggle
                                            checked={isNullUndefinedOrEmpty(item.checked) ? (item.weight === null || item.weight === undefined ? false : true) : item.checked}
                                            onChange={() => onChangeAssociateConsolidation(item)} disabled={!canEdit} />
                                    </Col>
                                </Row>
                            ))
                        }
                    </Col>
                </Row>
            </Panel>
        </div>
    );
};

SidePanelConfig.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_Object: PropTypes.object.isRequired,
};

export default SidePanelConfig;